// TOP 10 Holiday Parks (NZTop10) booking strategy.
//
// Booking URL: append `?checkIn=YYYY-MM-DDT12:00:00&checkOut=...&adults=N`
// to the bare per-room URL. The TOP 10 booking widget reads these on first
// paint and renders a populated cart with Add To Cart enabled. The
// "T12:00:00" (no Z, no offset) form is load-bearing — the page parses the
// value through `new Date(...)`, which is timezone-sensitive; noon-local
// keeps the calendar day stable across +/-12h zones (verified in
// discovery-report.md §Step 7). `adults=N` defaults to the request's
// `minCapacity` (Schnerp's single party-size axis); children/infants
// default to 0 since the request schema does not split them.
//
// Preview URL: returns the park-level overview page (`facility
// .extraAttributes.parkUrl`). The site-level reserveUrl points at one
// specific bookable card (e.g. `/cabin-queen-bed/`), which is too narrow
// for a "What sites does this park have?" alert. Park-level page lists
// every cabin/site, has the operator's photos, map embed, and amenities.

import { format } from "date-fns";

function formatNoon(date) {
  return `${format(date, "yyyy-MM-dd")}T12:00:00`;
}

export default {
  buildBookingUrl({ site, arrivalDate, departureDate, partySize }) {
    if (!arrivalDate || !departureDate) return site.reserveUrl;
    const params = new URLSearchParams({
      checkIn: formatNoon(arrivalDate),
      checkOut: formatNoon(departureDate),
      adults: String(partySize ?? 1),
      children: "0",
      infants: "0",
    });
    return `${site.reserveUrl}?${params.toString()}`;
  },

  buildPreviewUrl(site, facility) {
    return facility?.extraAttributes?.parkUrl ?? site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes:
            "Encoded as ?checkIn=YYYY-MM-DDT12:00:00. Noon form prevents timezone-induced calendar-day drift in the booking widget.",
        },
        departureDate: {
          status: "required",
          notes: "Encoded as &checkOut=YYYY-MM-DDT12:00:00.",
        },
        ref: {
          status: "ignored",
          notes:
            "site.reserveUrl is the per-room booking page; ref is not encoded.",
        },
        partySize: {
          status: "encoded",
          defaultValue: 1,
          notes:
            "Encoded as &adults=N. Schnerp's request schema doesn't split adults/children/infants, so children=0 and infants=0 are appended.",
        },
      },
    };
  },
};
